import executeQuery from "#lib/db"
import { log } from "#debug"

import type { RecipeIngredient } from "#types"

export const getIngredients = async ({ id }: { id: string }): Promise<RecipeIngredient[]> => {
	const list = await executeQuery({
		query: `
			select
				rec_ing.recipeIngredientID,
				rec_ing.recipeID,
				rec_ing.ingredientID,
				rec_ing.ingredientTypeID,
				rec_ing.quantityID,
				rec_ing.amount,
				coalesce(ing.ingredient, '') as ingredientName,
				coalesce(ing_typ.ingredientType, '') as ingredientTypeName,
				coalesce(qua.quantity, '') as quantityName
			from
				recipe_ingredients rec_ing
			left outer join
				ingredients ing on rec_ing.ingredientID = ing.ingredientID
			left outer join
				ingredient_types ing_typ on rec_ing.ingredientTypeID = ing_typ.ingredientTypeID
			left outer join
				quantities qua on rec_ing.quantityID = qua.quantityID
			where
				rec_ing.isActive=1 and
				recipeID=${id}
		`,
	})

	return list
}

export const addIngredients = async (body: RecipeIngredient) => {
	const query = `
		insert into recipe_ingredients(
			recipeID,
			ingredientID,
			ingredientTypeID,
			quantityID,
			amount,
			isActive
		) values (
			${body.recipeID},
			${body.ingredientID},
			${body.ingredientTypeID},
			${body.quantityID},
			'${body.amount}',
			1
		)
	`

	log(query)

	const results = await executeQuery({ query })

	return results
}

export const patchIngredients = async (body: RecipeIngredient) => {
	const query = `
		update
			recipe_ingredients
		set
			quantityID=${body.quantityID},
			ingredientTypeID=${body.ingredientTypeID},
			ingredientID=${body.ingredientID},
			isActive=${body.isActive},
			amount='${body.amount}',
		where
			recipeIngredientID=${body.recipeIngredientID}
			and recipeID=${body.recipeID}
	`

	log(query)

	const results = await executeQuery({ query })

	return results
}
